import React from "react";
import "./sideNav.css";
import { Accordion, Card, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb,faPersonBooth, faKeyboard, faBars, faHome, faUsers, faCubes, faCar, faAngleDown, faCircle, faClock, faTools, faWrench, faSearch, faPlug, faChartPie, faCogs, faChartBar, faTh, faFile } from '@fortawesome/free-solid-svg-icons'
import { Routes,
  Route,
  Link,
  Outlet } from 'react-router-dom'

class SideNav extends React.Component {
  render() {
    let mmhost = this.props.mmHost;
    return (
      <>
     <aside id="mainSidebar" className="mainSidebar">

          <div id="mainMenu">
              <div className="list-group panel">
                  {/*<Link to="" className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faHome}/><span>Home</span></Link>*/}
                  <a href= {mmhost + "/" + ""} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faHome}/><span>Home</span></a>
                  <a href= {mmhost + "/" + "operator/landing"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faPersonBooth}/><span>Operator Home</span></a>
                  <a href= {mmhost + "/" + "plan"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faCubes}/><span>Production Planning</span></a>
                  <a href= {mmhost + "/" + "resourceplanning"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faUsers}/><span>Resource Allocation</span></a>
                  <Link to="downtime" className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faClock}/><span>Downtime</span></Link>
                  <a href={mmhost + '/managementDashboard'} className='list-group-item' data-parent='#mainMenu'><FontAwesomeIcon icon={faWrench}/><span>Management Dashboard</span></a>
                  {/*<a href= {mmhost + "/" + "machine"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faTools}/><span>Analytics Page</span></a>*/}
                  <a href= {mmhost + "/" + "andon"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faTh}/><span>Andons</span></a>
                  <a href= {mmhost + "/" + "quality"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faSearch}/><span>Quality Control</span></a>
                  {/*<Link to="quality" className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faSearch}/><span>Quality Control</span></Link>*/}
                  <a href= {mmhost + "/" + "mis"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faChartPie}/><span>MIS</span></a>
                  <a href= {mmhost + "/" + "dispatchReportPage"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faFile}/><span>Dispatch Report</span></a>
                  <a href= {mmhost + "/" + "manageUsers"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faUsers}/><span>User Management</span></a>
                  <a href= {mmhost + "/" + "configuration"} className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faWrench}/><span>Settings Generic</span></a>
                  <Link to="leaderBoard" className="list-group-item" data-parent="#mainMenu"><FontAwesomeIcon icon={faUsers}/><span>Leaderboard</span></Link>
              </div>
          </div>
      </aside>
      </>
    );
  }
}

export default SideNav;
